import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './ep-pricing-esm-components-price-summary-price-summary.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { ModalDialog, ModalDialogContent, ModalDialogNav, ModalDialogCloseButton, ModalDialogHeader, ModalDialogTitle, ModalDialogBody, FlexBox, Divider, Typography } from '@vp/swan';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';
import { PriceInternal } from './ep-pricing-esm-components-price-price.component.js';

const PriceSummaryModal = forwardRef((props, ref) => {
  const {
    className,
    isModalOpen,
    onClose,
    priceContext,
    placeholdertext,
    basePrice,
    discountedBasePrice,
    totalListPrice,
    totalDiscountedPrice,
    setUpFee,
    discountedSetUpFee,
    ...rest
  } = props;
  const classNames = clsx(className, styles.priceSummary);
  const { t } = useLocalization(priceContext.locale);
  const renderPriceRow = (label, listPrice, discountedPrice, isBold = false) => /* @__PURE__ */ jsxs(FlexBox, { justifyContent: "space-between", ref, children: [
    /* @__PURE__ */ jsx(Typography, { fontSize: isBold ? "large" : "standard", fontWeight: isBold ? "bold" : "normal", ...rest, children: label }),
    /* @__PURE__ */ jsx(
      PriceInternal,
      {
        placeholdertext,
        priceConfig: {
          locale: priceContext.locale,
          currency: priceContext.currency,
          minimumFractionDigits: priceContext.minimumFractionDigits,
          vatInc: priceContext.vatInc,
          listPrice,
          discountedListPrice: discountedPrice
        },
        ref
      }
    )
  ] });
  return /* @__PURE__ */ jsx(
    ModalDialog,
    {
      variant: "standard",
      bodyWidth: "capped",
      isOpen: isModalOpen,
      onRequestDismiss: () => {
        onClose();
      },
      className: classNames,
      children: /* @__PURE__ */ jsxs(ModalDialogContent, { "aria-labelledby": t("priceSummaryModal"), children: [
        /* @__PURE__ */ jsx(ModalDialogNav, { children: /* @__PURE__ */ jsx(ModalDialogCloseButton, { accessibleText: t("priceSummaryCloseModal") }) }),
        /* @__PURE__ */ jsx(ModalDialogHeader, { children: /* @__PURE__ */ jsx(ModalDialogTitle, { children: t("priceSummary") }) }),
        /* @__PURE__ */ jsx(ModalDialogBody, { children: /* @__PURE__ */ jsxs(FlexBox, { flexDirection: "column", gap: 4, style: { width: "100%" }, ref, children: [
          /* @__PURE__ */ jsxs(FlexBox, { flexDirection: "column", gap: 3, children: [
            renderPriceRow(t("priceSummaryBasePrice"), basePrice, discountedBasePrice),
            renderPriceRow(t("priceSummarySetupFee"), setUpFee, discountedSetUpFee)
          ] }),
          /* @__PURE__ */ jsx(Divider, {}),
          renderPriceRow(t("priceSummarySubtotal"), totalListPrice, totalDiscountedPrice, true),
          /* @__PURE__ */ jsx(Typography, { fontSkin: "body-small", children: t(`priceSummaryTermsAndConditions`) })
        ] }) })
      ] })
    }
  );
});

export { PriceSummaryModal };
//# sourceMappingURL=ep-pricing-esm-components-price-summary-price-summary-modal.component.js.map
